export default "__VITE_ASSET__aZyXRxK0__"